import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  ModalController,
  AlertController
} from "ionic-angular";
import { Clipboard } from "@ionic-native/clipboard";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";
import { SelectAreaModalComponent } from "../select-area-modal/select-area-modal";

@Component({
  selector: "edit-cp-basic-info-modal",
  templateUrl: "edit-cp-basic-info-modal.html",
  providers: [SummaryServiceProvider]
})
export class ChangeBasicInfoCpModalComponent {
  text: string;
  data;
  preData;
  codSupport;
  cpName;
  currency;
  filterData: any;
  requestFields: any = {};
  categoryFilterList: any;
  myInput: any;
  parkingRemarksArray = [
    {
      id: "Parking Available",
      value: "Yes"
    },
    {
      id: "Parking Not Available",
      value: "No"
    }
  ];

  constructor(
    public platform: Platform,
    public params: NavParams,
    public alertCtrl: AlertController,
    public summaryService: SummaryServiceProvider,
    private clipboard: Clipboard,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController
  ) {
    this.text = "Hello World";
    let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
    if (userInfo) {
      this.currency = userInfo.currency;
    }
    this.data = this.params.get("data");
    // this.preData = { ...this.data, areaEntity: this.data.areaEntity };
    if (!this.data.newCategoryEntity) {
      this.data.newCategoryEntity = { id: 11, value: "Unknown" };
    }
    this.preData = JSON.parse(JSON.stringify(this.data));
    this.cpName = this.data.name;
    this.filterData = JSON.parse(localStorage.getItem("fuFilters"));
    console.log(this.filterData.networkType);
    this.categoryFilterList = this.filterData.categoryEntity.map(ele => {
      let element = {
        id: +ele.id,
        value: ele.value
      };
      return element;
    });
    this.codSupport = [
      { value: "TRUE", id: true },
      { value: "FALSE", id: false }
    ];
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  saveBasicInfo(id) {
    var payload: any = {};

    if (this.data.name !== this.preData.name) {
      payload.name = this.data.name;
    }

    if (this.data.nameLang.arabic !== this.preData.nameLang.arabic) {
      var nameLangObj: any = { arabic: this.data.nameLang.arabic };
      payload.nameLang = JSON.stringify(nameLangObj);
    }

    if (this.data.merchantInternalName !== this.preData.merchantInternalName) {
      payload.merchantInternalName = this.data.merchantInternalName;
    }

    if (
      this.data.managerUserEntity.uid !== this.preData.managerUserEntity.uid
    ) {
      payload.managerUserEntity = this.data.managerUserEntity.uid;
    }

    if (this.data.newCategoryEntity.id !== this.preData.newCategoryEntity.id) {
      payload.categoryId = this.data.newCategoryEntity.id;
    }

    if (this.data.phone !== this.preData.phone) {
      payload.phone = this.data.phone;
    }

    if (this.data.managerPhoneNumber !== this.preData.managerPhoneNumber) {
      payload.managerPhoneNumber = this.data.managerPhoneNumber;
    }

    if (this.data.tabletMobileNo !== this.preData.tabletMobileNo) {
      payload.tabletMobileNo = this.data.tabletMobileNo;
    }

    if (this.data.imei !== this.preData.imei) {
      payload.imei = this.data.imei;
    }

    if (this.data.remarks !== this.preData.remarks) {
      payload.remarks = this.data.remarks;
    }

    if (this.data.parcelLimit !== this.preData.parcelLimit) {
      payload.parcelLimit = this.data.parcelLimit;
    }

    if (this.data.networkType !== this.preData.networkType) {
      payload.networkType = this.data.networkType;
    }

    if (this.data.codSupport !== this.preData.codSupport) {
      payload.codSupport = this.data.codSupport;
    }

    if (this.data.parkingRemarks !== this.preData.parkingRemarks) {
      payload.parkingRemarks = this.data.parkingRemarks;
    }

    if (this.data.address !== this.preData.address) {
      payload.address = this.data.address;
    }

    if (this.data.addressLang.arabic !== this.preData.addressLang.arabic) {
      var adressLangObj: any = { arabic: this.data.addressLang.arabic };
      payload.addressLang = JSON.stringify(adressLangObj);
    }

    if (this.data.areaEntity.ids !== this.preData.areaEntity.ids) {
      payload.areaEntity = this.data.areaEntity.ids;
    }

    if (this.data.mapLink !== this.preData.mapLink) {
      payload.mapLink = this.data.mapLink;
    }

    if (this.data.lat !== this.preData.lat) {
      payload.lat = this.data.lat;
    }

    if (this.data.lng !== this.preData.lng) {
      payload.lng = this.data.lng;
    }
    if(this.currency=="SAR"){
      if (this.data.posTerminalId !== this.preData.posTerminalId) {
        payload.posTerminalId = this.data.posTerminalId;
      }
      if (this.data.posTerminalSn !== this.preData.posTerminalSn) {
        payload.posTerminalSn = this.data.posTerminalSn;
      }
    }
    // console.log("payload", payload);
    if (!this.isObjectEmpty(payload)) {
      this.summaryService.patchCPInfo(id, payload).then(res => {
        // console.log(res);
        this.viewCtrl.dismiss(true);
      });
    } else {
      this.viewCtrl.dismiss(true);
    }
  }

  getClipboardData() {
    this.clipboard.paste().then(
      (resolve: string) => {
        if (resolve) {
          let startIndex = resolve.indexOf("https");
          let text = resolve.slice(startIndex, resolve.length);
          this.data.mapLink = text;
        } else {
          alert("Failed");
        }
      },
      (reject: string) => {
        alert("Error: " + reject);
      }
    );
  }

  getClipboardDataForLatLng() {
    this.clipboard.paste().then(
      (resolve: string) => {
        if (resolve) {
          let splittedArray = resolve.split(",");
          this.data.lat = splittedArray[0];
          this.data.lng = splittedArray[1];
        } else {
          alert("Failed");
        }
      },
      (reject: string) => {
        alert("Error: " + reject);
      }
    );
  }

  isObjectEmpty(Obj) {
    for (var key in Obj) {
      if (Obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  selectArea() {
    const modal = this.modalCtrl.create(SelectAreaModalComponent, {
      data: this.data.areaEntity
    });
    modal.onDidDismiss(data => {
      if (data) {
        if (data.ids) {
          this.data.areaEntity = data;
        }
      }
    });
    modal.present();
  }

  confirmAreaSelection(id) {
    let message = `Are you sure the selected area is ${this.data.areaEntity.name}`;
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "Yes",
          handler: () => {
            this.saveBasicInfo(id);
          }
        }
      ]
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/edit-cp-basic-info/edit-cp-basic-info-modal.ts